<template>
    <div>
        <div class="container lnb d_container">
            <div class="contents_wrap">
                <div class="contents list-container">
                    <div class="title">{{ $route.meta.title }}
                        <el-button v-if="tab === 'streaming'" class="title_btn" @click="moveCreate" type="primary">등록</el-button>
                    </div>
                    <div class="list-content content tab-content">
                        <div
                            class="intro_tab col_2"
                            @click="moveDetail()"
                            :class="{ active: tab === 'basic' }"
                        >
                            기본정보
                        </div>
                        <div
                            class="intro_tab col_2"
                            :class="{ active: tab === 'streaming' }"
                        >
                            스트리밍 관리
                        </div>
                    </div>
                    <div class="list-content">
                        <live-klass-list-component :liveklassType="`liveKlassStreaming`"
                                                   :liveKlassKey="liveKlassKey"></live-klass-list-component>
                    </div>
                </div>
            </div>

            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import LiveKlassListComponent from "@/components/liveklass/LiveKlassListComponent";

export default {
    name: "LiveKlassDetailStreaming",
    mixins: [],
    components: {LiveKlassListComponent},
    provide() {
        return {};
    },
    props: {},
    data() {
        return {
            liveKlassKey: Number(this.$route.params.idx),
            tab: "streaming",
        };
    },
    created() {
        if (!util.isEmpty(this.$route.query.tab)) {
            this.tab = this.$route.query.tab;
        }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        moveDetail() {
            this.$router.push(`/content/liveklass/${this.liveKlassKey}`);
        },
        moveCreate() {
            // this.$router.replace(this.$route.path);
            this.$router.push(`/content/liveklass/${this.liveKlassKey}/streaming/create`);
        },
    },
    watch: {
        "$route.path": {
            deep: true,
            handler: function (val, oldVal) {
                if (
                    !util.isEmpty(this.$route.query.tab) &&
                    this.tab != this.$route.query.tab
                ) {
                    this.changeTab(this.$route.query.tab);
                }
                /*if (this.liveKlassKey != this.$route.params.idx) {
                    this.liveKlassKey = Number(this.$route.params.idx);
                }*/
            },
        },
    },
};
</script>

<style scoped></style>
